import type { Subscription } from "~~/types/subscription";

export const useSubscriptionStore = defineStore(
  "user-subscription",
  () => {
    const subscription = ref<Subscription | null>(null);

    const hasPlatformAccess = computed(() => {
      return subscription.value
        ? subscription.value.hasPlatformAccess
        : true;
    });
    const userStore = useUserStore();

    const hasSubmissionsLeft = computed(() => {
      return subscription.value
        ? subscription.value.canSubmitForm
        : !userStore.isLoggedIn;
    });

    function setSubscription(newSubscription: Subscription) {
      subscription.value = newSubscription;
    }

    function reset() {
      subscription.value = null;
    }

    return {
      subscription,
      hasPlatformAccess,
      hasSubmissionsLeft,

      setSubscription,
      reset,
    };
  },
);
